import React, { useEffect, useMemo, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import { useDispatch } from "react-redux";
import Services from "../../API/services";
import { getRroomPropertyAction } from "../../store/slices/propertySlice";
import { toast } from "react-toastify";

function LegalEntityPopup({ data, newData, showLegal, setShowLegal }) {


  // const [validations, setValidations] = useState(Validation3);
  const dispatch = useDispatch();
  const { AlertIcon } = Imagesdata || {};
  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    unregister,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [editMode, setEditMode] = useState(true)

  const { firmType, entityName, ownerAdharCertificate, ownerPanCertificate, gstNumber, GSTpicture, tanNumber, tanpicture, PropertyPanNumber, panpicture, rentpicture, chequepicture, bankName, branchName, accountHolder, accountNumber, ifsc, accountType } = watch()

  // useEffect(() => {
  //   const bankDetail = data?.bankDetails?.split("~");
  //     setValue("firmType", data.firmType);
  //     setValue("firmTypeEntity", firmType);
  //     setValue("gstNumber", gstNumber);
  //     setValue("tanNumber", tanNumber);
  //     setValue("PropertyPanNumber", PropertyPanNumber);
  //     setValue("entityName", data?.legalName);
  //     if (bankDetail?.length > 0) {
  //       setValue("bankName", bankDetail[0]);
  //       setValue("branchName", bankDetail[1]);
  //       setValue("accountHolder", bankDetail[2]);
  //       setValue("accountNumber", bankDetail[3]);
  //       setValue("ifsc", bankDetail[4]);
  //       setValue("accountType", bankDetail[5]);
  //     }
  // }, []);


  const onSubmit = async () => {

    const {
      GSTpicture,
      PropertyPanNumber,
      chequepicture,
      firmTypeEntity,
      firmType,
      gstNumber,
      ownerAdharCertificate,
      ownerPanCertificate,
      panpicture,
      rentpicture,
      tanNumber,
      tanpicture,
      bankName,
      branchName,
      accountHolder,
      accountNumber,
      ifsc,
      entityName,
      accountType
    } = getValues();

    let bodyFormData3 = new FormData();
    bodyFormData3.append("firmType", firmType);
    bodyFormData3.append("accountType", accountType);
    bodyFormData3.append("PropertyPanNumber", PropertyPanNumber);
    bodyFormData3.append("tanNumber", tanNumber);
    bodyFormData3.append("gstNumber", gstNumber);
    bodyFormData3.append("legalName", entityName);
    // bodyFormData3.append("accountType", accountType);
    bodyFormData3.append(
      "bankDetails",
      bankName +
      "~" +
      branchName +
      "~" +
      accountHolder +
      "~" +
      accountNumber +
      "~" +
      ifsc +
      "~" +
      accountType
    );
    if (rentpicture[0]) {
      bodyFormData3.append("rentAgreement", rentpicture?.[0]);
    }
    if (GSTpicture[0]) {
      bodyFormData3.append("gstCertificate", GSTpicture?.[0]);
    }
    if (tanpicture[0]) {
      bodyFormData3.append("tanCertificate", tanpicture?.[0]);
    }
    if (chequepicture[0]) {
      bodyFormData3.append("cancelCheque", chequepicture?.[0]);
    }
    if (ownerAdharCertificate[0]) {
      bodyFormData3.append("owneradharCertificate", ownerAdharCertificate?.[0]);
    }
    if (ownerPanCertificate[0]) {
      bodyFormData3.append("ownerpanCertificate", ownerPanCertificate?.[0]);
    }
    if (panpicture?.[0]) {
      bodyFormData3.append("PropertyPanCertificate", panpicture?.[0]);
    }

    try {
      let res = await Services.property.updateRRoomPropertyService({
        id: newData?.id,
        body: bodyFormData3,
      });

      if (res.status === true || res.status === 200) {
        setShowLegal(false);
        dispatch(getRroomPropertyAction());
        if (editMode) {
          toast.success("Legal Entity Successfully Updated !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        } else {
          toast.success("Legal Entity Successfully Created !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
      }
    } catch (error) { }
  };

  return (
    <Modal size='lg' show={showLegal} onHide={() => setShowLegal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ownership Transfer Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-4'>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <span>Legal Entity</span>
          <Row className="popup-form onboardForm p-3">
            <Col xs={6} className="form-group">
              <label>Firm Type</label>
              <select {...register("firmType", { required: "Please select firm type*" })}>
                <option value="">Select Firm</option>
                <option value="Proprietorship">Proprietorship</option>
                <option value="Partnership">Partnership</option>
                <option value="Corporation">Corporation</option>
                <option value="Private Limited">Private Limited</option>
              </select>
              {errors.firmType && (
                <p className="fs-8" style={{ color: "red" }}>{errors.firmType.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Entity Name</label>
              <input
                type="text"
                placeholder="Enter Entity Name"
                {...register("entityName", {
                  required: "Entity Name is required",
                  minLength: { value: 3, message: "At least 3 characters required" },
                })}
              />

              {errors.entityName && (
                <p className="fs-8" style={{ color: "red" }}>{errors.entityName.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload Owner Adhar Certificate</label>
              <input
                {...register("ownerAdharCertificate", { required: !editMode ? "Owner Adhar Certificate is required" : false })}
                type="file"
                accept="application/pdf"
              />
              {errors.ownerAdharCertificate && (
                <p className="fs-8" style={{ color: "red" }}>{errors.ownerAdharCertificate.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload Owner PAN Certificate</label>
              <input
                {...register("ownerPanCertificate", { required: !editMode ? "Owner PAN Certificate is required" : false })}
                type="file"
                accept="application/pdf"
                id="ownerPanCertificate"
              />
              {errors.ownerPanCertificate && (
                <p className="fs-8" style={{ color: "red" }}>{errors.ownerPanCertificate.message}</p>
              )}
            </Col>

            <Col xs={6} className="form-group">
              <label htmlFor="gstNumber">GST No. *</label>
              <input
                id="gstNumber"
                type="text"
                placeholder="Enter GST number"
                {...register("gstNumber", {
                  required: "GST Number is required",
                  pattern: {
                    value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
                    message: "Enter a valid GST Number"
                  }
                })}
              />

              {errors.gstNumber && (
                <p className="fs-8" style={{ color: "red" }}>{errors.gstNumber.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload GST Certificate</label>
              <input
                {...register("GSTpicture", { required: !editMode ? "GST Certificate is required" : false })}
                type="file"
                accept="application/pdf"
                id="GSTpicture"
              />

              {errors.GSTpicture && (
                <p className="fs-8" style={{ color: "red" }}>{errors.GSTpicture.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>TAN No.</label>
              <input
                type="text"
                placeholder="Enter Tan Number"
                {...register("tanNumber")}
              />
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload TAN Document</label>
              <input
                {...register("tanpicture", { required: !editMode ? "TAN Certificate is required" : false })}
                type="file"
                accept="application/pdf"
                id="tanpicture"
              />
              {errors.tanpicture && (
                <p className="fs-8" style={{ color: "red" }}>{errors.tanpicture.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label htmlFor="PropertyPanNumber">PAN No. *</label>
              <input
                id="PropertyPanNumber"
                type="text"
                placeholder="Enter PAN number"
                {...register("PropertyPanNumber", {
                  required: "PAN Number is required",
                  pattern: {
                    value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    message: "Enter a valid PAN Number"
                  }
                })}
              />
              {errors.PropertyPanNumber && (
                <p className="fs-8" style={{ color: "red" }}>{errors.PropertyPanNumber.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload PAN Certificate</label>
              <input
                {...register("panpicture", { required: !editMode ? "PAN Certificate is required" : false })}
                type="file"
                accept="application/pdf"
                id="panpicture"
              />
              {errors.panpicture && (
                <p className="fs-8" style={{ color: "red" }}>{errors.panpicture.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload Rent Agreement</label>
              <input
                {...register("rentpicture", { required: !editMode ? "Rent Agreement is required" : false })}
                type="file"
                accept="application/pdf"
                id="rentpicture"
              />
              {errors.rentpicture && (
                <p className="fs-8" style={{ color: "red" }}>{errors.rentpicture.message}</p>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <label>Upload Cancel Cheque</label>
              <input
                {...register("chequepicture", { required: !editMode ? "Cancel Cheque is required" : false })}
                type="file"
                accept="application/pdf"
                id="chequepicture"
              />
              {errors.chequepicture && (
                <p className="fs-8" style={{ color: "red" }}>{errors.chequepicture.message}</p>
              )}
            </Col>
            <Col xs={12} className="form-group mt-3">
              <h6>Bank account details</h6>
            </Col>
            <Col xs={12} className="form-group bankDetails">
              <Row>
                <Col xs={6} className="form-group">
                  <label htmlFor="bankName">Bank Name</label>
                  <input
                    id="bankName"
                    type="text"
                    placeholder="Enter bank name"
                    {...register("bankName", { required: "Bank Name is required" })}
                  />
                  {errors.bankName && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.bankName.message}</p>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label htmlFor="branchName">Branch Name</label>
                  <input
                    id="branchName"
                    type="text"
                    autoFocus
                    placeholder="Enter branch"
                    {...register("branchName", { required: "Branch Name is required" })}
                  />
                  {errors.branchName && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.branchName.message}</p>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label htmlFor="accountHolder">Account Holder</label>
                  <input
                    id="accountHolder"
                    type="text"
                    placeholder="Enter bank account name"
                    {...register("accountHolder", { required: "Account Holder is required" })}
                  />
                  {errors.accountHolder && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.accountHolder.message}</p>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label htmlFor="accountNumber">Account Number</label>
                  <input
                    id="accountNumber"
                    type="text"
                    autoFocus
                    placeholder="Enter account number"
                    {...register("accountNumber", { required: "Account Number is required" })}
                  />
                  {errors.accountNumber && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.accountNumber.message}</p>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label htmlFor="ifsc">IFSC</label>
                  <input
                    id="ifsc"
                    type="text"
                    autoFocus
                    placeholder="Enter IFSC code"
                    {...register("ifsc", {
                      required: "IFSC code is required",
                      pattern: {
                        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: "Enter a valid IFSC code"
                      }
                    })}
                  />
                  {errors.ifsc && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.ifsc.message}</p>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label htmlFor="accountType">Account Type</label>
                  <select
                    id="accountType"
                    {...register("accountType", { required: "Account Type is required" })}
                  >
                    <option value="">Select Account Type</option>
                    <option value="saving">Saving</option>
                    <option value="current">Current</option>
                  </select>
                  {errors.accountType && (
                    <p className="fs-8" style={{ color: "red" }}>{errors.accountType.message}</p>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xs={12} className="form-group justify-content-between flex">

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default LegalEntityPopup;
